module.exports = __webpack_public_path__ + "img/1.77b1658a.jpg";